<img [src]="imageSource + '?t=' + currentTimestamp" />
